// extracted by mini-css-extract-plugin
module.exports = {"blogs-main-container":"blogs_blogs-main-container__6uk_Y","blogs-main-container_div_h2":"blogs_blogs-main-container_div_h2__oDQCq"};